import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { site } from '@yola/ws-sdk';
import blocks from 'src/js/modules/blocks';
import linkTypes from '../constants/link-types';

const buildGroupedBlocksOptions = (
  initialPageId,
  initialReference,
  matchedPage,
  activePage,
  currentPageBlocksOptions
) => [
  {
    label: matchedPage.name,
    options: [
      {
        label: `#${initialReference}`,
        value: initialReference,
        pageId: initialPageId,
      },
    ],
  },
  {
    label: activePage.name,
    options: currentPageBlocksOptions,
  },
];

const useBlocksOptions = (initialLinkConfig = null) => {
  const activePageId = useSelector(site.selectors.getActivePageId);
  const activePage = useSelector((state) => site.selectors.getPage(state, activePageId));
  const pages = useSelector(site.selectors.getPages);

  const currentPageBlocksOptions = useMemo(() => blocks.helpers.getBlocksReadableNames(), []);

  const blocksOptions = useMemo(() => {
    const isAnchorFromOtherPage =
      initialLinkConfig?.linkType === linkTypes.ANCHOR &&
      initialLinkConfig?.pageId &&
      initialLinkConfig?.reference &&
      activePageId !== initialLinkConfig.pageId;

    if (isAnchorFromOtherPage) {
      const matchedPage = pages.find((page) => page.id === initialLinkConfig.pageId);

      if (matchedPage) {
        return buildGroupedBlocksOptions(
          initialLinkConfig.pageId,
          initialLinkConfig.reference,
          matchedPage,
          activePage,
          currentPageBlocksOptions
        );
      }
    }

    return currentPageBlocksOptions;
  }, [initialLinkConfig, activePageId, activePage, pages, currentPageBlocksOptions]);

  return { blocksOptions };
};

export default useBlocksOptions;
